import { siteCall } from "../utils/WebCall";
import urls from '../utils/urls'


export const findIfPaidUserForCrown = async (props) => {
    const { setShowCrown, userData } = props;
    const subscriptionData = userData?.subscription || {};
    const additionalParameter = Object.keys(subscriptionData || {})[0];

    const subscriptionName = Object.keys(subscriptionData)[0];
    // console.log("subscriptionName: ", subscriptionName);
    const currentDate = Math.floor(new Date().getTime() / 1000);
    const endDate = subscriptionData?.[additionalParameter]?.periodEnd;

    if (
    (subscriptionName === "productivity pro" ||
        subscriptionName === "business") &&
    endDate >= currentDate
    ) {
    setShowCrown(true);
    } else if (subscriptionName === "free") {
    setShowCrown(false);
    }
};


export const sendNotesByEmail = (meeting_id, meeting_type, to_email) => {
    let params = {
        meeting_id: meeting_id,
        meeting_type: meeting_type,
        to_email: to_email
    }
    return siteCall({
        url: urls.send_notes_email,
        method: "POST",
        body: JSON.stringify(params),
        // successCallback: successCallback,
        // errorCallback: errorCallback,
      });
}